export const BAC_HOME = {
  vision: {
    title: {
      ar: 'رؤية المدرسة',
      fr: "Vision de l'école",
      en: 'School vision',
    },
    description: {
      ar: `تهدف هذه التربية عالية الجودة إلى تكوين طالبة متعددة اللغات، مبدعة وقادرة على التكيف مع التغيرات المستمرة، ذات شخصية متميزة، مستقلة، نشطة ومنفتحة على العالم.`,
      fr: 'Cet enseignement de qualité vise à former une étudiante plurilingue, créatrice apte à s’adapter aux perpétuels changements, ayant une personnalité distincte, autonome, active et ouverte à l’international.',
      en: `This quality education aims to train a multilingual student, a creative individual capable of adapting to perpetual changes, with a distinctive, independent, active personality, and open to international opportunities.`,
    },
    attachments: [], // TODO :attach: Gir0 2025.png,
    type: 'home/vision',
    order: 1,
    isArchived: false,
    image: 'GIR SI 1 2025.jpg',
  },
};
